import {LabelRegular, TextMedium} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import {AxiosError} from 'axios'
import React from 'react'

import {usePlant} from '../../hooks/usePlant'
import {useTranslation} from '../../hooks/useTranslation'

type RolePlantLookupChipProps = {
  plantId: string
  countryId: string
  error?: Error
}

export const RolePlantLookupChip = ({plantId, countryId}: RolePlantLookupChipProps) => {
  const {t} = useTranslation()

  const plantQueryInfo = usePlant({plantId, countryId})

  if (plantQueryInfo.isLoading) {
    return <CircularProgress size="20" />
  }

  if (plantQueryInfo.isError) {
    return (
      <div className="flex flex-col items-start">
        <TextMedium className="text-foreground">{plantId}</TextMedium>
        <TextMedium className="text-foreground">Error: Could not load plant</TextMedium>
        <TextMedium className="text-foreground">
          {(plantQueryInfo.error as AxiosError).message}
        </TextMedium>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-start">
      <LabelRegular className="text-foreground_faded">{t('manageUser.plant')}</LabelRegular>
      <TextMedium className="text-foreground">{plantQueryInfo.data?.plantName}</TextMedium>
      <LabelRegular className="text-foreground_faded">
        {plantQueryInfo.data?.plantNumber}
      </LabelRegular>
    </div>
  )
}
